// import "react-select/dist/react-select.css";

import React, { Component } from "react";

// import { Async, AsyncCreatable } from "react-select";
import Async from "react-select/lib/Async";
import AsyncCreatable from "react-select/lib/AsyncCreatable";
import Button from "../CustomButton/CustomButton.jsx";
import { FormattedMessage } from "react-intl";
// import debounce from "debounce-promise";
import _ from "lodash-es";
import { v4 } from "uuid";

class CustomSelect extends Component {
  constructor(props) {
    super(props);
    // console.log("CustomSelect constructor");
    this.state = {
      backspaceRemoves: false,
      options: [],
      inputValue: props.inputValue,
      menuIsOpen: !!props.inputValue
    };

    this.debouncedpromiseOptions = _.debounce(this.promiseOptions, 250);
  }
  promptTextCreator() {
    return (
      <div>
        <Button fill>+</Button>
        <FormattedMessage id={"ids_create"} />
      </div>
    );
  }

  // cleanInput = (inputValue) => {
  //   // Strip all non-number characters from the input
  //   return inputValue.replace(/[^0-9]/g, "");
  // }

  onChange = (value, { action }) => {
    console.log("CustomSelect onChange", value, action);

    switch (action) {
      case "select-option":
        this.setState({ inputValue: value });
        this.props.onSelected(value.data ? value : value.value);
        break;
      default:
        return;
    }
  };

  onNewOptionClick(options) {
    if (this.props.onCreate) {
      this.props.onCreate(options);
    }
    // console.log("onNewOptionClick", options, this.state)
    this.setState({
      value: options,
      v: options.value
    });

    this.props.onSelected({
      [this.props.label]: { name: options.value }
    });
  }

  isValidNewOption(label) {
    return true;
  }

  switchToMulti() {
    this.setState({
      multi: true,
      value: [this.state.value]
    });
  }

  switchToSingle() {
    this.setState({
      multi: false,
      value: this.state.value ? this.state.value[0] : null
    });
  }

  promiseOptions = inputValue =>
    new Promise(async (resolve, reject) => {
      if (inputValue) {
        const optionsRequest = await this.props.fetchData(
          inputValue ? inputValue : this.props.inputValue
        );
        if (undefined === optionsRequest) resolve([]);
        const options = optionsRequest.options;
        // console.log("promiseOptions resolve", inputValue, options);
        resolve(options);
      } else {
        // resolve([]);
      }
    });

  toggleBackspaceRemoves() {
    this.setState({
      backspaceRemoves: !this.state.backspaceRemoves
    });
  }
  toggleCreatable() {
    this.setState({
      creatable: !this.state.creatable
    });
  }

  handleInputChange = (inputValue, { action }) => {
    // console.log(
    //   "CustomSelect  handleInputChange",
    //   action,
    // );

    switch (action) {
      // case "set-value":
      case "input-change":
        this.setState({ inputValue });
        // console.log("input-change", inputValue, this.props.inputValue);
        this.props.onSelected(inputValue);

        return;

      case "menu-close":
        console.log("menu-close", inputValue, "-", this.props.inputValue);
        // let menuIsOpen = undefined;
        // if (this.props.inputValue) {
        //   menuIsOpen = true;
        // }
        this.setState({
          menuIsOpen: false
        });
        if (inputValue) this.props.onSelected(inputValue);
        return;
      default:
        return;
    }
  };

  render() {
    //    var modalStyles = { overlay: { zIndex: 1000 } };
    // console.log('CustomSelect value', this.props)
    const AsyncComponent = this.props.creatable ? AsyncCreatable : Async;
    // const autoload = false; //this.props.autoload ? this.props.autoload : false;
    // console.log("CustomSelect render", this.props);

    const autofocus = this.props.autoFocus ? this.props.autoFocus : false;

    return (
      <div className="section">
        {/* <pre>inputValue: "{this.props.inputValue}"</pre> */}
        <AsyncComponent
          key={v4()}
          // cacheOptions
          defaultOptions
          // inputValue={this.props.inputValue}
          inputValue={this.state.inputValue && this.state.inputValue.label}
          value={this.props.inputValue}
          onInputChange={this.handleInputChange}
          loadOptions={this.promiseOptions}
          noOptionsMessage={() => (
            <FormattedMessage id={"ids_noResultsFound"} />
          )}
          placeholder={<FormattedMessage id={"ids_typeToSearch"} />}
          loadingMessage={() => <FormattedMessage id={"ids_loading"} />}
          closeMenuOnSelect={true}
          openMenuOnFocus={true}
          defaultMenuIsOpen={this.state.menuIsOpen}
          autoFocus={autofocus}
          onChange={this.onChange}
          blurInputOnSelect={true}
        />
      </div>
    );
  }
}

export default CustomSelect;
